import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../../../components/header/Header";
import CallToAction from "../../../../components/call-to-action/CallToAction";
import Footer from "../../../../components/footer/Footer";
import CopyRight from "../../../../components/footer/CopyRight";

const ForMarketersPage = () => {
  return (
    <div className="main-page-wrapper p0">

      <Helmet>
        <title>
          For Marketers || Octy AI
        </title>
      </Helmet>
      {/* End Page SEO Content */}

      {/* =============================================
        Header
      ==============================================  */}
      <Header/>
      {/* End Header */}

      {/* =============================================
				Hero Banner
			============================================== */}
      <div className="hero-banner-twelve">
        <div className="bg-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-8 col-sm-10 pb-150">
                <h1 className="hero-heading font-source-code-pro" data-aos="fade-up">
                For Marketers
                </h1>
                <p
              className="hero-sub-heading"
              data-aos="fade-up"
              data-aos-delay="100"
                >
                    Customer insight + Smart campaigns
                </p>
                <div data-aos="fade-up" data-aos-delay="200">
              <Link to="/book-a-call" className="get-start-btn">
                Book a call{" "}
                <i className="fa fa-angle-right ml-1" aria-hidden="true"></i>
              </Link>
            </div>
              </div>
              <div className="col-lg-5 col-md-4">
                <img
                  src="images/assets/marketers.png"
                  alt="media"
                  className="img-meta d-none d-md-block"
                />
              </div>
            </div>
                <img
                src="images/shape/233.svg"
                alt="shape"
                className="shapes shape-four"
                />
                <img
                src="images/shape/234.svg"
                alt="shape"
                className="shapes shape-five"
                />
                <img
                src="images/shape/235.svg"
                alt="shape"
                className="shapes shape-six"
                />
                <img
                src="images/shape/236.svg"
                alt="shape"
                className="shapes shape-seven"
                />
                <img
                src="images/shape/232.svg"
                alt="shape"
                className="shapes shape-eight"
                />
          </div>
        </div>
        {/* /.bg-wrapper */}
      </div>
      {/* End Hero Banner */}

      {/* =====================================================
          Workflows
      ===================================================== */}
      <div className="fancy-feature-one">
        <div className="container">
            <div className="title-style-two">
                <h2>Design AI workflows your way</h2>
            </div>
            <div className="text-wrapper">
            <p className="font-source-code-pro"> AI gives you the tools to create highly-effective customer retention campaigns.</p>
            <p className="font-source-code-pro">Here are a few examples of how clients use our tools.</p>
            </div>


          <div className="block-wrapper pt-80">
            <div className="block-style-nine">
              <div className="row align-items-center">
                <div
                  className="col-lg-7 col-md-9 m-auto"
                  data-aos="fade-right"
                  data-aos-duration="600"
                >
                  <div className="illustration-holder">
                    <img src="images/assets/segments.png" alt="jigsaw with people"  style={{width: "60%", height: "100"}}/>
                  </div>
                  {/* /.illustration-holder */}
                </div>
                <div
                  className="col-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="600"
                >
                  <div className="text-wrapper">
                    {/* <h6>Workflow #1</h6> */}
                    <h3 className="title font-source-code-pro">
                    Segmentation
                    </h3>
                    <p className="font-source-code-pro">
                        Grouping customers into segments relative to shared attributes and
                        behaviours allows you to define each customer on a granular level at scale.
                        With this you can:
                    </p>
                    <ul>
                        <li>
                        <p>• Design specially crafted offers that appeal to every segment; maximising customer engagement.</p>
                        </li>
                        <li>
                        <p>• Focus time and resources on those customers that are most valuable.</p>
                        </li>
                        <li>
                        <p>• Retain abandoned carts in real-time by using Octy AI’s live segmentation engine.</p>
                        </li>
                    </ul>
                  </div>
                  {/* /.text-wrapper */}
                </div>
              </div>
            </div>
            {/* /.block-style-nine */}
            <div className="block-style-nine">
              <div className="row align-items-center">
                <div
                  className="col-lg-7 col-md-9 m-auto order-lg-last"
                  data-aos="fade-left"
                  data-aos-duration="600"
                >
                  <div className="illustration-holder">
                    <img src="images/assets/churn.png" alt="woman with chart" />
                  </div>{" "}
                  {/* /.illustration-holder */}
                </div>
                <div
                  className="col-lg-5 order-lg-first"
                  data-aos="fade-right"
                  data-aos-duration="600"
                >
                  <div className="text-wrapper">
                    {/* <h6>Workflow #2</h6> */}
                    <h3 className="title font-source-code-pro">
                    Churn prediction analysis
                    </h3>
                    <p className="font-source-code-pro">
                    Create automated workflows that filter your top customers who are likely to churn soon and push them into tailored retention campaigns. 
                    Uncover your business's top 10 reasons for customer churn.
                    </p>
                  </div>{" "}
                  {/* /.text-wrapper */}
                </div>
              </div>
            </div>{" "}
            {/* /.block-style-nine */}
            <div className="block-style-nine">
              <div className="row align-items-center">
                  {/* #Image */}
                <div
                  className="col-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="600"
                >
                  <div className="text-wrapper">
                    {/* <h6>management</h6> */}
                    <h3 className="title font-source-code-pro">
                    According to HubSpot “Only a 5% increase in customer retention can increase company revenue by 25-95%.”
                    </h3>
                    <p className="font-source-code-pro">
                    read more here → {"   "}
                    <a href="https://blog.hubspot.com/service/customer-retention#:~:text=an%20existing%20customer.-,ROI,-%3A%20A%205%25%20increase" target="_blank">
                    <img src="images/logo/hubspot-logo.png" style={{ height: 35, width: 120 }}/>
                    </a>
                    </p>
                    <p>Octy AI gives your team the tools to reach this level of growth in weeks, not years.</p>
                  </div>{" "}
                  {/* /.text-wrapper */}
                </div>
              </div>
            </div>{" "}
            {/* /.block-style-nine */}
            <div className="block-style-nine">
              <div className="row align-items-center">
                <div
                  className="col-lg-7 col-md-9 m-auto order-lg-last"
                  data-aos="fade-left"
                  data-aos-duration="600"
                >
                  <div className="illustration-holder">
                    <img src="images/assets/personal.png" style={{width: "60%", height: "100"}} alt="woman and shoe" />
                  </div>
                  {/* /.illustration-holder */}
                </div>
                <div
                  className="col-lg-5 order-lg-first"
                  data-aos="fade-right"
                  data-aos-duration="600"
                >
                  <div className="text-wrapper">
                    {/* <h6>Personalisation</h6> */}
                    <h3 className="title font-source-code-pro">
                    Personalisation
                    </h3>
                    <p className="font-source-code-pro">
                    Add hyper-personalisation to each customer touchpoint. 
                    </p>
                    <p className="font-source-code-pro">From personalised targeted website content to personalised sales copy and product recommendations.</p>
                  </div>{" "}
                  {/* /.text-wrapper */}
                </div>
              </div>
            </div>
            {/* /.block-style-nine */}
          </div>
        </div>
      </div>
      {/* End Workflows */}

      {/* =====================================================
           CTA
      ===================================================== */}
      <CallToAction />
      {/* End CTA */}

      {/* =====================================================
        Footer
      ===================================================== */}
      <footer className="theme-footer-seven mt-120 md-mt-100">
        <div className="lg-container">
          <div className="container inner-btn-black">
            <Footer/>
          </div>

          <div className="container">
            <div className="bottom-footer">
              <CopyRight />
            </div>
          </div>
        </div>
        {/* /.lg-container */}
      </footer>
      {/* End Footer */}

      
    </div>
  );
};

export default ForMarketersPage;